
import { BlackJackBetMoveEffect } from './../component/bj_bet_move_effect';
import Utility from "../../../../utility/utility";
import BlackJackTableModule from "./blackjack_table_module";
import BlackJackTableView from "./blackjack_table_view";
import BlackJackTableModel from "./blackjack_table_model";
import BlackJackTableSeatView from "./blackjack_table_seat_view";
import BlackJackTableBetView from "./blackjack_table_bet_view";
import BlackJackUtility from "../../Utility/blackJack_utility";
import { BlackJack } from "../../net/proto/proto_blackjack_game";
import ModuleManager from "../../../../framework/core/module_manager";
import { ButtonState, BlackJackRoomInfo, BlackJackGameState, GameResultState, BlackJackBetType, BlackJackChipPos, BlackJackCardState } from "./black_table_data";
import { Room } from '../../../table/net/proto/proto_poker_room';
import DialogTips from '../../../public/module/dialog_tips/dialog_tips';
import PokerTablePokerBase from '../../../table/module/poker_table/poker_table_poker_base';
import BlackJackSound from '../../blackjack_sound';
import Record from '../../../hall/module/record/record';
import Setting from '../../../hall/module/setting/setting';
import LanguageManager from '../../../../manager/language_manager';
import MorePanel from "../../../table/module/game_morepanel/game_morepanel" //导入
import ModelData from '../../../public/model_data';
import TableChat from '../../../table/module/tablechat/tablechat';
import EventManager from '../../../../manager/event_manager';
import UserDataManager from '../../../../manager/user_manager';
import GameUtil from '../../../../utility/game_util';
import { joinUtil } from '../../../public/join_util';
import SceneManager from '../../../../manager/scene_manager';
export default class BlackJackTableLogic extends cc.Component {


    protected module: BlackJackTableModule = null
    protected view: BlackJackTableView = null
    protected model: BlackJackTableModel = null
    private roomInfo: BlackJackRoomInfo = null;


    private curBetView: BlackJackTableBetView = null;
    private curSeatView: BlackJackTableSeatView = null;
    //===================================================
    myPlayerInfo: BlackJack.IPlayer = null

    allPosInfo: BlackJack.IPosInfo[] = []
    countWaitTime = 0;

    totalTime = 0
    gameState: BlackJackGameState = 0
    myPlayerSeatNo = 0;
    private myPlayerId: number | Long = 0;
    private curOperate = 0;
    myPlayerHistoryBetInfo: BlackJack.Player.BetInfo[] = []
    moreBetClickPos = 0
    sideBetClickPos = 0
    curInsurancePos = 0;   //发送保险POS用
    ackId: number = -1
    lastSendAckId: number = -1
    isBomb = false;
    gameSettleReason: number = GameResultState.Reset
    showPosChipMove: Function
    cardMoveFun: Function
    betViewMove: Function
    constructor(module: BlackJackTableModule, view: BlackJackTableView, model: BlackJackTableModel) {
        super();
        this.module = module
        this.view = view
        this.model = model

    }
    onInit(intentData: any) {


        this.initBtnState(ButtonState.Init_Button)
        this.view.initTable()
        this.view.bankerView.setLogic(this)
        this.view.bankerView.setTableView(this.view)
        //cc.log(ModelData.instance.roomInfo.PlayRuleData)//.game_BetMin
        // this.view.sideView.setBlackJackModel(this.model)
        // this.view.sideView.setBlackJackView(this.view)
        // this.view.sideView.setBlackJackLogic(this)
        // this.view.sideView.setPlayerInfo(null)
    }
    //多占一个下注位置
    moreBetPos(seatNo: number) {

        if (this.curBetView != null) {
            this.curBetView.lights[0].active = false;
            if (this.curBetView.posInfoArr.length == 0) {
                this.curBetView.otherBet.active = true;
            }
        }
        if (seatNo != 0) {
            this.curOperate = seatNo
            this.curBetView = this.view.getBetViewByPos(seatNo)
            this.curBetView.showNotice(false)
            this.initBtnState(ButtonState.Show_Bet)
        }
        this.moreBetClickPos = seatNo;
        this.sideBetClickPos = 0;

        //this.curBetView.setPosInfo(this.myPlayerInfo,null)

    }
    //下旁注
    betOther(pos: number) {
        if (this.myPlayerSeatNo != 0) {
            return;
        }
        //cc.log("logic收到旁注：" + pos)
        this.sideBetClickPos = pos
        this.moreBetClickPos = 0;
        this.curBetView = this.view.getBetViewByPos(pos)
        this.initBtnState(ButtonState.Show_Bet)

    }
    changePos(pos: number) {
        this.model.send_OccupySeat_request(Number(pos))
    }
    StartGame() {
        //this.initTable();
        //this.initBetView();
        // this.testWait();
    }
    initBtnState(type: ButtonState) {

        this.view.buttons.active = true;
        this.view.minBtn.node.active = false;
        this.view.maxBtn.node.active = false;
        this.view.betBtn.node.active = false;
        this.view.doubleBtn.node.active = false;
        this.view.fenpaiBtn.node.active = false;
        this.view.wantBtn.node.active = false;
        this.view.stopBtn.node.active = false;
        this.view.continueBetBtn.node.active = false;
        this.view.completeBetBtn.node.active = false;
        this.view.continuePlayBtn.node.active = false;
        this.view.skipBtn.node.active = false;
        this.view.buyBtn.node.active = false;
        this.view.notBuyBtn.node.active = false;
        this.view.insuranceBg.active = false;
        switch (type) {
            case ButtonState.Init_Button:
                this.addBtnEvent()
                break;
            case ButtonState.Show_Bet: //下注
                this.view.minBtn.node.active = true;
                this.view.maxBtn.node.active = true;
                this.view.betBtn.node.active = true;
                this.view.skipBtn.node.active = true;
                let betView = this.view.getBetViewByPos(this.curOperate)
                this.showBetBtnState()
                this.showContState()
                this.showSkipBtn()

                break;
            case ButtonState.Show_Operate://要牌 分牌 停牌
                this.view.doubleBtn.node.active = true;
                this.view.fenpaiBtn.node.active = true;
                this.view.wantBtn.node.active = true;
                this.view.stopBtn.node.active = true;

                let cardInfo = this.curBetView.getCardInfo(this.curOperate).cardInfo
                Utility.setBjBtnGray(this.view.doubleBtn, !cardInfo.doubleBet)

                Utility.setBjBtnGray(this.view.fenpaiBtn, !cardInfo.enableRight)
                Utility.setBjBtnGray(this.view.wantBtn, !cardInfo.moreCard)
                Utility.setBjBtnGray(this.view.stopBtn, !cardInfo.noMoreCard)




                break;
            case ButtonState.Show_Insurance://买保险
                this.curBetView = this.view.getBetViewByPos(this.myPlayerSeatNo)
                if (this.curBetView.posInfoArr.length > 0 && this.curBetView.posInfoArr[0].base != 0) {
                    this.curInsurancePos = this.myPlayerSeatNo;
                    this.showInsurance()
                }
                break;
        }
    }

    checkInsurancePos(mySeatView: BlackJackTableSeatView) {
        let isOtherBet = false
        for (let i = 0; i < this.view.allSeatViewList.length; i++) {
            if (this.isCanBuyInsurance(i)) {
                this.view.buyBtn.node.active = true;
                this.view.notBuyBtn.node.active = true;
                this.curInsurancePos = this.view.allSeatViewList[i].posInfo.pos
                this.curBetView = this.view.allBetViewList[i]
                isOtherBet = true;
                this.showInsurance()
                break;
            }
        }
        if (!isOtherBet) {
            mySeatView.stopCountTime()
        }
    }
    isCanBuyInsurance(i) {
        if (this.view.allSeatViewList[i].posInfo == null) {
            return false
        }
        if (this.view.allSeatViewList[i].seatNo == this.myPlayerSeatNo) {
            return false
        }
        if (this.myPlayerInfo.coinBalance < this.view.allSeatViewList[i].posInfo.base / 2)//金额足够
        {
            return false
        }
        if (this.view.allSeatViewList[i].posInfo.playerId != this.myPlayerId) //是否是主角本人
        {
            return false
        }
        if (this.view.allSeatViewList[i].posInfo.insuranceFlag) //是否已经购买过保险
        {
            return false
        }
        return true;
    }
    showInsurance(isShow: boolean = true) {
        // this.view.insuranceTxt.string = "是否为" + this.curInsurancePos + "位购买保险"
        // this.view.insuranceBg.active = isShow
        if (this.curBetView) {
            this.curBetView.showNotice(isShow, "Insurance")

            if (this.curBetView.posInfoArr.length > 0 && this.myPlayerInfo.coinBalance >= this.curBetView.posInfoArr[0].base / 2) {
                Utility.setBjBtnGray(this.view.buyBtn, false)
            }
            else {
                Utility.setBjBtnGray(this.view.buyBtn, true)
            }
        }

        this.view.buyBtn.node.active = isShow
        this.view.notBuyBtn.node.active = isShow

    }
    showContState() {
        if (this.myPlayerSeatNo == 0 || this.gameState != BlackJackGameState.Beting) {
            this.view.continueBetBtn.node.active = false
            this.view.completeBetBtn.node.active = false;
            return;
        }

        if (this.getMainPlayerBase() != 0) {
            this.view.continueBetBtn.node.active = false
            this.view.completeBetBtn.node.active = true;
        }
        else {
            this.view.continueBetBtn.node.active = true
            Utility.setBjBtnGray(this.view.continueBetBtn, true)
            if (this.myPlayerInfo.historyBetInfo != null && this.myPlayerInfo.historyBetInfo.base != 0)//this.myPlayerInfo.historyBetInfo.base!=0
            {
                let money: number = this.myPlayerInfo.historyBetInfo.base
                money += this.myPlayerInfo.historyBetInfo.pair
                money += this.myPlayerInfo.historyBetInfo.b21p3
                if (this.myPlayerInfo.coinBalance > money && this.myPlayerSeatNo == this.myPlayerInfo.historyBetInfo.pos) {
                    Utility.setBjBtnGray(this.view.continueBetBtn, false)
                }
            }
        }

    }

    addBtnEvent() {
        this.view.buttonMask.node.on('click', this.on_click, this)
        this.view.minBtn.node.on('click', this.on_click, this)
        this.view.maxBtn.node.on('click', this.on_click, this)
        this.view.betBtn.node.on('click', this.on_click, this)
        this.view.continueBetBtn.node.on('click', this.on_click, this)
        this.view.continuePlayBtn.node.on('click', this.on_click, this)
        this.view.doubleBtn.node.on('click', this.on_click, this)
        this.view.fenpaiBtn.node.on('click', this.on_click, this)
        this.view.stopBtn.node.on('click', this.on_click, this)
        this.view.wantBtn.node.on('click', this.on_click, this)
        this.view.completeBetBtn.node.on('click', this.on_click, this)
        this.view.skipBtn.node.on('click', this.on_click, this)
        this.view.buyBtn.node.on('click', this.on_click, this)
        this.view.notBuyBtn.node.on('click', this.on_click, this)
        //this.view.quitBtn.node.on('click', this.on_click, this)
        //this.view.recordBtn.node.on('click', this.on_click, this)
        //this.view.settingBtn.node.on('click', this.on_click, this)
        this.view.moreBtn.node.on('click', this.on_click, this)


    }

    unbindBtnClickEvent() {
        // let self = this
        this.view.buttonMask.node.targetOff(this)
        this.view.minBtn.node.targetOff(this)
        this.view.maxBtn.node.targetOff(this)
        this.view.betBtn.node.targetOff(this)
        this.view.continueBetBtn.node.targetOff(this)
        this.view.continuePlayBtn.node.targetOff(this)
        this.view.doubleBtn.node.targetOff(this)
        this.view.buttonReady.node.targetOff(this)
        this.view.fenpaiBtn.node.targetOff(this)
        this.view.stopBtn.node.targetOff(this)
        this.view.wantBtn.node.targetOff(this)
        this.view.completeBetBtn.node.targetOff(this)
        this.view.skipBtn.node.targetOff(this)
        this.view.buyBtn.node.targetOff(this)
        this.view.notBuyBtn.node.targetOff(this)
        // this.view.quitBtn.node.targetOff(this)
        //this.view.recordBtn.node.targetOff(this)
        //this.view.settingBtn.node.targetOff(this)
        this.view.moreBtn.node.targetOff(this)
    }
    protected on_click(event: cc.Button): boolean {

        let isClickValid = Utility.btnClickValid(100)
        if (!isClickValid) {
            return isClickValid
        }
        Utility.playButtonSound()
        let node: cc.Node = event.node
        if (node == this.view.minBtn.node) {
            this.minBtnOnClick(node);
        }
        else if (node == this.view.maxBtn.node) {
            this.maxBtnOnClick();
        }
        else if (node == this.view.betBtn.node) {
            this.betBtnOnClick()
        }
        else if (node == this.view.continueBetBtn.node) {
            this.continueBetBtnOnclick()
        }
        else if (node == this.view.doubleBtn.node) {
            this.doubleBtnOnClick()
        }
        else if (node == this.view.fenpaiBtn.node) {
            this.fenpaiBtnClick()
        }
        else if (node == this.view.stopBtn.node) {
            this.stopBtnOnClick()
        }
        else if (node == this.view.wantBtn.node) {
            this.wantBtnOnClick()
        }
        else if (node == this.view.completeBetBtn.node) {
            this.completeBetBtnOnClick()
        }
        else if (node == this.view.skipBtn.node) {
            this.skipBtnOnClick()
        }
        // else if (node == this.view.quitBtn.node) {
        //     this.quitBtnOnClick()
        // }
        else if (node == this.view.buyBtn.node) {
            this.buyInsurace()
        }
        else if (node == this.view.notBuyBtn.node) {
            this.notBuyInsurace()
        }
        // else if (node == this.view.recordBtn.node) {
        //     this.recordBtnOnClick()
        // }
        // else if (node == this.view.settingBtn.node) {
        //     this.settingBtnOnClick()
        // }
        else if (node == this.view.moreBtn.node) {
            this.moreBtnOnClick()
        }
        // else if (node == this.view.funMaskBtn.node) {
        //     this.funMaskBtnOnClick()
        // }
        return isClickValid
    }

    moreBtnOnClick() {
        cc.log("aaaa")
        //ModuleManager.instance.showModule(TableChat)
        //ModuleManager.instance.hideModule("TableChat")
        ModuleManager.instance.showModule(MorePanel)
    }
    settingBtnOnClick() {

        this.view.moreBtn.node.active = true
        ModuleManager.instance.showModule(Setting, "setting")
    }
    recordBtnOnClick() {

        this.view.moreBtn.node.active = true
        ModuleManager.instance.showModule(Record, "record")
    }
    notBuyInsurace() {
        //optional uint32 pos = 1;//1~5为左手位
        //optional bool rejected = 2; //不买保险
        this.model.send_Insurance_request(this.curInsurancePos, true)
        this.showInsurance(false);

    }
    buyInsurace() {
        this.model.send_Insurance_request(this.curInsurancePos, false)
        this.showInsurance(false);

    }
    quitBtnOnClick() {

        this.view.moreBtn.node.active = true
        if (this.getMainPlayerBase() != 0) {
            ModuleManager.instance.toastKey("public_cannotLeave");
        }
        else {
            //let leaveCallFunc = () => {
            this.view.unschedule(this.showPosChipMove)
            this.view.unschedule(this.cardMoveFun)
            this.view.unschedule(this.betViewMove)
            this.model.request_leave_room()
            //}
            //ModuleManager.instance.showModule(DialogTips, { Content: '确定要离开房间吗？', EnterCallBack: leaveCallFunc })
        }


        // ModuleManager.instance.showDialog_Confirm("您确认要退出房间吗？", () => {
        //     this.model.request_leave_room();
        // }, null)

    }
    betBtnOnClick() {
        //pos = 1; //pos ~= player.player_pos时表示 旁注
        // bet_type = 2;//下注类型 0 表示 底注 1表示完美对子 2表示21+3 4续压 5旁注
        // auto_follow_double = 3; //自动双倍，为false时只跟单倍 旁注有意义
        // auto_follow_right = 4;//自动跟右手，为false时只跟左手 旁注有意义
        // bet=5;//下注金额
        // this.abab++;
        // this.view.bankerView.showHand(this.abab)
        // return
        if (this.view.sliderView.node.active) {

            this.sendBet(Number(this.view.sliderView.slideBetNum))
            this.view.sliderView.showPanel(false)
        }
        else {
            this.view.sliderView.showPanel(true)
        }



    }
    maxBtnOnClick() {
        this.view.sliderView.showPanel(false)
        if (this.myPlayerInfo.coinBalance >= this.roomInfo.maxPoint) {
            this.sendBet(this.roomInfo.maxPoint)
        }
        else {
            this.sendBet(this.myPlayerInfo.coinBalance)
        }
    }

    minBtnOnClick(node: cc.Node) {
        this.view.sliderView.showPanel(false)
        this.sendBet(this.roomInfo.minPoint)
    }
    sendBet(num: number) {
        //num = Math.round(num * 100) / 100

        let betType = -1
        let pos = 0;
        if (this.moreBetClickPos != 0)  //占了一个新位置  下注
        {
            this.curBetView = this.view.getBetViewByPos(this.moreBetClickPos)
            this.curOperate = this.moreBetClickPos
            betType = this.curBetView.getBetSetp()
            cc.log("新位置setp" + betType)
            pos = this.moreBetClickPos
            this.curBetView.changeSetp()
            this.initBtnState(ButtonState.Show_Bet)
        }
        else if (this.sideBetClickPos != 0) //下旁注
        {
            pos = this.sideBetClickPos
            betType = BlackJackBetType.side
            //下旁注后 按钮状态根据main玩家  落座位置显示
            this.curBetView = this.view.getBetViewByPos(this.myPlayerSeatNo)
            this.curOperate = this.myPlayerInfo.playerPos
            this.initBtnState(ButtonState.Show_Bet)
        }
        else {
            this.curBetView = this.view.getBetViewByPos(this.myPlayerSeatNo)
            if (this.myPlayerSeatNo == 0 && this.sideBetClickPos == 0) {
                ModuleManager.instance.toast("请先选择您要下旁注位置！");
                return;
            }
            pos = this.myPlayerSeatNo;
            betType = this.curBetView.getBetSetp()
            //cc.log("betSetp:" + betType)
            this.curBetView.changeSetp()
            this.initBtnState(ButtonState.Show_Bet)
        }
        this.moreBetClickPos = 0
        this.sideBetClickPos = 0
        this.model.send_Bet_request(pos, betType, false, false, num)
    }
    showBetBtnState() {

        let minStr = GameUtil.currencyFormatting(this.roomInfo.minPoint)
        let maxStr = GameUtil.currencyFormatting(this.roomInfo.maxPoint)
        this.view.minBtnTxt.string = "[(（" + minStr + ")）"
        if (this.myPlayerInfo.coinBalance > this.roomInfo.maxPoint) {
            this.view.maxBtnTxt.string = "[(" + maxStr + ")"
            this.view.sliderView.maxNum = this.roomInfo.maxPoint;
        }
        else {
            maxStr = GameUtil.currencyFormatting(this.myPlayerInfo.coinBalance);
            this.view.maxBtnTxt.string = "[(" + maxStr + ")"
            this.view.sliderView.maxNum = Math.floor(this.myPlayerInfo.coinBalance);
        }

        let isEnoughMoney: boolean = this.myPlayerInfo.coinBalance >= this.roomInfo.minPoint
        if (!isEnoughMoney) {
            //this.view.maxBtnTxt.string = "[(" + minStr + ")"            
        }

        Utility.setBtnGray(this.view.maxBtn,!isEnoughMoney);

        let setp = 0
        setp = this.curBetView.getBetSetp()
        // cc.log("curBetViewSeatNo"+this.curBetView.seatNo)
        // cc.log("curBetViewSetp:"+setp)


        //有钱可下最低注 当前下注位置还没下完
        //有钱可下最低注 我点了旁注
        if ((isEnoughMoney && setp <= 2) || (isEnoughMoney && this.sideBetClickPos != 0)) {
            Utility.setBtnGray(this.view.minBtn, false)

            Utility.setBtnGray(this.view.maxBtn, false)
            Utility.setBjBtnGray(this.view.betBtn, false)
        }
        else {
            Utility.setBtnGray(this.view.minBtn, true)
            Utility.setBtnGray(this.view.maxBtn, true)
            Utility.setBjBtnGray(this.view.betBtn, true)

        }
    }

    completeBetBtnOnClick() {

        this.view.sliderView.showPanel(false)
        if (this.myPlayerSeatNo != 0) {
            let mainSeatView = this.view.getSeatViewById(this.myPlayerId)
            mainSeatView.stopCountTime()
            mainSeatView.showState("CompleteBet", true)
        }

        this.view.hideEmptyBet()
        this.view.hideBetViewLight();
        this.initBtnState(ButtonState.None)
        this.model.send_Bet_Finish(this.myPlayerSeatNo)
    }

    doubleBtnOnClick() {


        Utility.setBjBtnGray(this.view.fenpaiBtn, true)
        Utility.setBjBtnGray(this.view.doubleBtn, true)
        this.model.send_DoubleBet_request(this.curOperate)

    }

    continueBetBtnOnclick() {

        //this.initBtnState(ButtonState.None)
        let pos = this.myPlayerSeatNo
        if (this.myPlayerInfo.historyBetInfo != null) {
            if (this.myPlayerInfo.historyBetInfo.base != 0) {
                this.model.send_Bet_request(pos, BlackJackBetType.base, false, false, this.myPlayerInfo.historyBetInfo.base)
            }
            if (this.myPlayerInfo.historyBetInfo.pair != 0) {
                this.model.send_Bet_request(pos, BlackJackBetType.pair, false, false, this.myPlayerInfo.historyBetInfo.pair)
            }
            if (this.myPlayerInfo.historyBetInfo.b21p3 != 0) {
                this.model.send_Bet_request(pos, BlackJackBetType.three, false, false, this.myPlayerInfo.historyBetInfo.b21p3)
            }
        }
        this.curBetView = this.view.getBetViewByPos(this.myPlayerSeatNo)
        this.curBetView.changeSetp()
        this.initBtnState(ButtonState.Show_Bet)
        this.showContState()
        this.view.sliderView.showPanel(false)
    }
    skipBtnOnClick() {
        this.curBetView.changeSetp()
        this.curBetView.showLights()
        this.showSkipBtn()
    }
    wantBtnOnClick() {
        Utility.setBjBtnGray(this.view.fenpaiBtn, true)
        Utility.setBjBtnGray(this.view.doubleBtn, true)


        this.model.send_MoreCard_request(this.curOperate)
    }
    stopBtnOnClick() {
        this.initBtnState(ButtonState.None)

        this.model.send_NoMoreCard_request(this.curOperate)

    }
    fenpaiBtnClick() {
        Utility.setBjBtnGray(this.view.fenpaiBtn, true);
        this.model.send_EnableRight_request(this.curOperate)
    }


    onShow(intentData: any) {
    }

    onHide() {
        this.reset()
    }

    reset() {

        this.unbindBtnClickEvent()
        this.view.setMatchRankBtnClickCallback(null)

    }

    on_destroy() {
        this.reset()

    }


    //显示跳过按钮状态
    showSkipBtn() {
        this.view.skipBtn.node.active = false
        return;
        if (this.myPlayerSeatNo == 0) {
            Utility.setBtnGray(this.view.skipBtn, true)
            return;
        }
        this.curBetView = this.view.getBetViewByPos(this.myPlayerSeatNo)
        if (this.curBetView == null) {
            cc.log(this.myPlayerSeatNo)
        }
        let betType = this.curBetView.getBetSetp()
        if (this.view.skipBtn.node.active) {
            if (betType == 1) {
                Utility.setBtnGray(this.view.skipBtn, false)
            }
            else {
                Utility.setBtnGray(this.view.skipBtn, true)
            }
        }
    }

    onNetMsgGameInfo(protoData: BlackJack.GameInfo) {


        BlackJackSound.playBg()
        this.countWaitTime = protoData.stateExpiredTime - protoData.time
        this.view.initTable()
        this.myPlayerInfo = protoData.mainPlayer

        this.allPosInfo = protoData.posInfo
        this.gameState = protoData.state
        this.curOperate = this.myPlayerInfo.playerPos
        this.myPlayerSeatNo = this.myPlayerInfo.playerPos
        this.myPlayerId = this.myPlayerInfo.playerId;
        this.view.buttons.active = false

        this.initPanel()
        this.setPanelData()
        this.view.sideView.setPlayerInfo(this.myPlayerInfo)
        if (protoData.bankerCards[1] != 0) {
            this.view.bankerView.initBank(protoData.bankerCards, protoData.bankerCardPoint)
        }
        else {
            this.view.bankerView.initBank(protoData.bankerCards, 0)
        }
        this.initRoomInfo(protoData)
        this.totalTime = protoData.stateDuration
        if (this.gameState == BlackJackGameState.Operateing) {
            this.curOperate = protoData.currentPos
        }

        this.switchGameState(this.gameState, false)
    }

    showAllCountTime(cdTime: number, isShow: boolean = true) {
        for (let i = 0; i < this.view.allSeatViewList.length; i++) {
            if (this.view.allSeatViewList[i].posInfo == null) {
                continue
            }
            if (isShow) {
                if (this.view.allSeatViewList[i].posInfo.isMainSeat) {
                    if (this.gameState == BlackJackGameState.Beting) {
                        this.view.allSeatViewList[i].countTime(this.totalTime, cdTime)
                    }
                    else if (this.gameState == BlackJackGameState.Buy_Insurance) {
                        if (this.view.allSeatViewList[i].posInfo.base != 0) {
                            this.view.allSeatViewList[i].countTime(this.totalTime, cdTime)
                        }
                    }
                }
            }
            else {
                this.view.allSeatViewList[i].stopCountTime()
            }

        }
    }
    //轮询玩家操作
    pollingPlayer(cdTime: number) {
        cc.log("轮询" + this.curOperate)
        if (this.curOperate == 0) {
            return
        }
        let pos = (this.curOperate - 1) % 5 + 1
        this.curSeatView = this.view.getSeatView(pos)
        let hand = Number(this.curSeatView.getParentPos().name)
        this.view.bankerView.showHand(hand + 1)
        if (this.curBetView) {
            this.curBetView.PokerMask(-1)
        }
        this.curBetView = this.view.getBetViewByPos(pos)
        this.curBetView.curSelect.active = true;

        this.curBetView.PokerMask(this.curOperate)
        if (!this.curSeatView.posInfo.isMainSeat) {
            this.curSeatView = this.view.getSeatViewById(this.curSeatView.posInfo.playerId)
        }
        this.curSeatView.countTime(this.totalTime, cdTime)
        if (this.curSeatView.posInfo.playerId == this.myPlayerInfo.playerId) {

            this.initBtnState(ButtonState.Show_Operate)
            let boo = this.myPlayerInfo.coinBalance >= this.curBetView.posInfoArr[0].base

            Utility.setBjBtnGray(this.view.doubleBtn, !boo)
            if (this.curBetView.posInfoArr[0].cardInfo.enableRight) {
                Utility.setBjBtnGray(this.view.fenpaiBtn, !boo)
            }


        }
    }

    showPanel() {
        let base: number = 0;
        for (let i = 0; i < this.view.allSeatViewList.length; i++) {
            this.view.allSeatViewList[i].showPanel()
            base = this.getMainPlayerBase()
            this.view.allBetViewList[i].showPanel()
            this.view.allBetViewList[i].setBetInfo()
            this.view.allBetViewList[i].showPoker()
            this.view.allBetViewList[i].showSideBetBtn()
        }

    }
    //主玩家自己的底注是否有下  如果下注了 那么坐下和旁观按钮皆不显示
    getMainPlayerBase() {

        if (this.myPlayerSeatNo == 0) {
            if (!this.myPlayerInfo) {
                return 0
            }
            if (this.myPlayerInfo.betInfo.length == 0) {
                return 0
            }
            return this.myPlayerInfo.betInfo[0].base
        }
        let betView = this.view.getBetViewByPos(this.myPlayerSeatNo)
        if (betView.posInfoArr.length == 0) {
            return 0
        }
        return betView.posInfoArr[0].base
    }


    setPanelData() {

        for (let i = 0; i < this.allPosInfo.length; i++) {


            let index = (this.allPosInfo[i].pos - 1) % 5 + 1
            if (this.myPlayerSeatNo == index) {

                //this.emojiMap[this.allPosInfo[i].playerId]=this.view.allSeatViewList[2].node.parent
                this.view.allSeatViewList[2].addPosInfo(this.allPosInfo[i])
                this.view.allBetViewList[2].addPosInfo(this.allPosInfo[i])
                if (this.gameState == BlackJackGameState.Beting) {
                    this.view.allSeatViewList[2].showState("CompleteBet", this.allPosInfo[i].betFinish)
                    if (!this.allPosInfo[i].betFinish) {
                        this.checkEmptyBet()
                        this.showContState()
                    }
                }
                continue
            }
            this.setPosInfo(index, this.allPosInfo[i])
        }
        cc.log("sendsendsendsend")
        //EventManager.instance.dispatch("get_seatView_Info",this.emojiMap)
        this.showPanel();
    }
    setPosInfo(i: number, posInfo: BlackJack.IPosInfo) {
        let seatView = this.view.getSeatView(i)
        //this.emojiMap[posInfo.playerId]=seatView.node.parent
        seatView.addPosInfo(posInfo)
        let betView = this.view.getBetViewByPos(i)
        // let betInfo: BlackJack.Player.IBetInfo = this.getBetInfoByPos(i)
        betView.addPosInfo(posInfo)

        if (this.gameState == BlackJackGameState.Beting) {
            seatView.showState("CompleteBet", posInfo.betFinish)
        }



        //this.myPlayerInfo.betInfo
        //betView.setBetInfo(this.myPlayerInfo)
    }

    initPanel() {

        for (let i = 0; i < this.view.allBetViewList.length; i++) {
            this.view.allSeatViewList[i].reset()
            this.view.allSeatViewList[i].setLogic(this)
            this.view.allBetViewList[i].reset()
            this.view.allBetViewList[i].setLogic(this)
            this.view.allBetViewList[i].setMainPlayerInfo(this.myPlayerInfo)
        }
        this.setSeatNo()

    }
    setSeatNo() {
        if (this.myPlayerSeatNo != 0)//玩家本人是旁注  那么显示座位 按1-5显示
        {
            for (let i = 0; i < this.view.allSeatViewList.length; i++) {
                if (i == 2) {
                    this.view.allSeatViewList[i].setSeatNo(this.myPlayerSeatNo)
                    this.view.allBetViewList[i].setSeatNo(this.myPlayerSeatNo)
                    continue
                }
                let seatNo = BlackJackUtility.getOtherSeatNo(this.myPlayerSeatNo, i)
                this.view.allSeatViewList[i].setSeatNo(seatNo)
                this.view.allBetViewList[i].setSeatNo(seatNo)

            }
        }
        else {
            for (let i = 0; i < this.view.allSeatViewList.length; i++) {
                this.view.allSeatViewList[i].setSeatNo(i + 1)
                this.view.allBetViewList[i].setSeatNo(i + 1)
            }
        }
    }


    initRoomInfo(protoData: BlackJack.GameInfo) {
        this.roomInfo = new BlackJackRoomInfo()
        this.roomInfo.roomId = protoData.roundSign
        this.roomInfo.minPoint = ModelData.instance.roomInfo.PlayRuleData.game_BetMin


        this.view.sliderView.minNum = this.roomInfo.minPoint;
        this.roomInfo.maxPoint = ModelData.instance.roomInfo.PlayRuleData.game_BetMax
        this.view.roomIdMaxTxt.string = this.roomInfo.maxPoint.toString()
        this.view.roomIdTxt.string = protoData.roundSign

        this.module.eventDispatch("Game_Table_Start");

    }
    //倒计时通知
    onNetMsgTimeoutNotify(protoData: BlackJack.TimeoutNotify) {
        //timeout=1;//还剩多久超时
        //event=2;////0:下注倒计时事件 2：发牌结束倒计时事件 3：保险倒计时事件 4：操作倒计时事件 888：ACK通知
        //pos=3;//0:表示房间 1~5为左手位 6~10为左手位

        if (protoData.event == BlackJackGameState.AskEvent) {
            this.ackId = protoData.ackId
            let a = protoData.ackId % 10
            if (protoData.ackId % 10 == 6) {
                this.sendAckId(5)
            }
            return;
        }
        this.countWaitTime = protoData.timeout
        this.totalTime = protoData.totalTimeout;
        this.gameState = protoData.event;

        this.curOperate = protoData.pos;

        if (protoData.event == BlackJackGameState.Beting) {
            this.myPlayerInfo.betInfo.length = 0;
            this.myPlayerInfo.historyBetInfo = protoData.lastBetInfo
        }
        this.view.bankerView.showHand(0)
        this.switchGameState(protoData.event)

    }

    switchGameState(state: number, isInit = true) {
        switch (state) {
            case BlackJackGameState.Beting:
                if (isInit) {
                    this.gameSettleReason = GameResultState.Reset
                    this.view.initTable()
                }
                this.view.hideSeatMask()
                this.gameState = BlackJackGameState.Beting
                this.showAllCountTime(this.countWaitTime)
                BlackJackSound.playStartGame()
                if (this.myPlayerSeatNo != 0) {
                    this.curOperate = this.myPlayerSeatNo;
                    this.curBetView = this.view.getBetViewByPos(this.curOperate)
                    this.curBetView.showLights()
                    this.moreBetClickPos = 0
                    this.sideBetClickPos = 0
                    this.initBtnState(ButtonState.Show_Bet)
                }
                break;
            case BlackJackGameState.Give_One_Card:
                this.view.hideEmptyBet()
                this.view.hideBetViewLight();
                break;
            case BlackJackGameState.Give_Two_Card:
                this.initBtnState(ButtonState.None)

                break;
            case BlackJackGameState.Buy_Insurance:
                this.showAllCountTime(this.countWaitTime)
                this.initBtnState(ButtonState.Show_Insurance)
                break;
            case BlackJackGameState.Operateing:
                this.showInsurance(false)
                this.pollingPlayer(this.countWaitTime)
                break;
        }
    }

    //找到Main玩家最后一次下注位置
    checkLastBet() {
        if (this.myPlayerSeatNo != 0 && this.myPlayerInfo.latestBetPos != 0) //如果玩家是坐下的 并且有最后一次下注位置
        {
            this.curBetView = this.view.getBetViewByPos(this.myPlayerInfo.latestBetPos)
        }
        else if (this.myPlayerInfo.latestBetPos == 0 && this.myPlayerSeatNo != 0)//如果玩家最后一次下注信息为0 那么找到他的落座位置
        {
            this.curBetView = this.view.getBetViewByPos(this.myPlayerSeatNo)
        }
    }

    //保险通知
    onNetMsgInsuranceNotify(protoData: BlackJack.InsuranceNotify) {
        //optional uint32 pos = 1;//1~5为左手位
        //optional int32 player_id = 3; //该座位下底注的玩家ID，即主玩家
        //optional double insurance=2;//保险金额
        //optional int32 coin_balance = 4; //玩家金币余额
        let mainView: BlackJackTableSeatView = this.view.getSeatViewById(protoData.playerId)
        mainView.setPlayerCoin(protoData.playerId,protoData.coinBalance)

        let seatView: BlackJackTableSeatView = this.view.getSeatView(protoData.pos)
        let betView: BlackJackTableBetView = this.view.getBetViewByPos(protoData.pos)
        seatView.posInfo.insuranceFlag = true;
        betView.posInfoArr[0].insuranceFlag = true
        if (protoData.insurance > 0) {
            seatView.posInfo.insurance = protoData.insurance
            betView.posInfoArr[0].insurance = protoData.insurance
            betView.chipMove(mainView.chipPos, betView.chipPosList[BlackJackChipPos.insurance], betView.insuranceEffect, protoData.insurance)

            let money = parseFloat(protoData.insurance.toString()) + parseFloat(betView.posInfoArr[0].base.toString())
            betView.delayShowCoin(protoData.pos, money)
            this.sendAckId(1.5)
        }
        if (protoData.playerId == this.myPlayerId) {
            this.myPlayerInfo.coinBalance = protoData.coinBalance
            this.checkInsurancePos(mainView)
        }
        else {
            let hasOther: boolean = false
            for (let i = 0; i < this.view.allBetViewList.length; i++) {

                if (this.view.allBetViewList[i].posInfoArr[0]) {
                    cc.log(this.view.allBetViewList[i].seatNo)
                    cc.log(this.view.allBetViewList[i].posInfoArr[0].insuranceFlag)
                    let isNoBuy = this.view.allBetViewList[i].posInfoArr[0].insuranceFlag
                    if (!isNoBuy && this.view.allBetViewList[i].posInfoArr[0].playerId == protoData.playerId) {
                        hasOther = true
                    }
                }
            }
            if (!hasOther) {
                mainView.stopCountTime()
            }
        }




    }
    //停牌通知
    onNetMsgNoMoreCardNotify(protoData: BlackJack.NoMoreCardNotify) {

        //optional uint32 pos = 1;//1~5为左手位 6~10为左手位
        //optional CardInfo card_info =2;
        //optional uint32 next_pos = 3;//下一个操作位 0表示庄家操作 1~5左手位 6~10右手位
        this.initBtnState(ButtonState.None)
        let seatNo = (protoData.pos - 1) % 5 + 1
        let betView = this.view.getBetViewByPos(seatNo)
        betView.curSelect.active = false;
        protoData.cardInfo.cardPoint.length = 1;
        betView.addCardInfo(protoData.pos, protoData.cardInfo)
        betView.PokerMask(-1)

        let seatView = this.view.getSeatView(seatNo)
        seatView.showState("StopCard", true)
        seatView.stopCountTime()
    }

    //要牌通知
    onNetMsgMoreCardNotify(protoData: BlackJack.MoreCardNotify) {
        //optional uint32 pos = 1;//1~5为左手位 6~10为左手位
        //optional CardInfo card_info =2;
        //optional uint32 next_pos = 3;//下一个操作位 0表示庄家操作 1~5左手位 6~10右手位
        let seatNo = (protoData.pos - 1) % 5 + 1
        let betView = this.view.getBetViewByPos(seatNo)

        if (protoData.cardInfo.status != BlackJackCardState.Normal) {
            let seatView = this.view.getSeatView(seatNo)
            seatView.stopCountTime()
            this.initBtnState(ButtonState.None)
        }
        betView.curSelect.active = false;
        betView.addCardInfo(protoData.pos, protoData.cardInfo, false)
        this.curOperate = protoData.nextPos;
        //==============================================================

        this.makePokerMove(protoData.pos, betView, protoData.cardInfo.cards)
        betView.delayShowPoint()


    }
    //分牌通知
    onNetMsgEnableRightNotify(protoData: BlackJack.EnableRightNotify) {
        //pos = 1;
        //player_id = 2; //该座位下底注的玩家ID，即主玩家
        //left_card_info = 3;
        //right_card_info = 4;
        // message BetInfo {
        //     optional int32 bet = 1; //基础下注数额
        //     optional int32 player_id = 2; //玩家ID
        //     optional int32 coin_balance = 3; //玩家金币余额
        // }
        //left_bet_info = 5;//每个玩家收到的不一样，都包含该位置主玩家的数据与自己在该位置所下的旁注数据
        //right_bet_info = 6;//每个玩家收到的不一样，都包含该位置主玩家的数据与自己在该位置所下的旁注数据

        let seatView = this.view.getSeatViewById(protoData.playerId)

        seatView.setPlayerCoin( protoData.leftBetInfo[0].playerId,protoData.leftBetInfo[0].coinBalance)

        this.curBetView = this.view.getBetViewByPos(protoData.pos)
        this.curBetView.curSelect.active = true;
        this.curBetView.showPokerSeparate(protoData)

        this.curBetView.baseEffect.purposeNode = this.curBetView.chipPosList[BlackJackChipPos.base]
        this.curBetView.baseEffect.recycleAllBet()

        this.curBetView.baseEffect.purposeNode = this.curBetView.chipPosList[BlackJackChipPos.leftBase]
        this.curBetView.baseEffect.showBet(this.curBetView.posInfoArr[0].base)

        this.curBetView.baseRightEffect.startNode = seatView.chipPos
        this.curBetView.baseRightEffect.purposeNode = this.curBetView.chipPosList[BlackJackChipPos.rightBase]
        this.curBetView.baseRightEffect.checkBet(this.curBetView.posInfoArr[0].base)


    }
    //双倍通知
    onNetMsgDoubleBetNotify(protoData: BlackJack.DoubleBetNotify) {
        // optional uint32 pos = 1;//1~5为左手位 6~10为左手位
        // optional int32 player_id = 3; //该座位下底注的玩家ID，即主玩家
        // optional CardInfo card_info = 2;
        // message BetInfo {
        //     optional int32 bet = 1; //下注数额
        //     optional int32 player_id = 2; //玩家ID
        //     optional int32 coin_balance = 3; //玩家金币余额
        // }
        // repeated BetInfo bet_info = 5;//每个玩家收到的不一样，都包含该位置主玩家的数据与自己在该位置所下的旁注数据
        // optional uint32 next_pos = 4;//下一个操作位 0表示庄家操作 1~5左手位 6~10右手位
        protoData.cardInfo.cardPoint.length = 1;
        let seatNo = (protoData.pos - 1) % 5 + 1
        let seatView = this.view.getSeatViewById(protoData.playerId)
        seatView.setPlayerCoin(protoData.betInfo[0].playerId,protoData.betInfo[0].coinBalance)
        seatView.stopCountTime()
        let betView = this.view.getBetViewByPos(seatNo)
        betView.addCardInfo(protoData.pos, protoData.cardInfo, false)
        betView.curSelect.active = false;
        let startNode = seatView.chipPos
        let endNode = null
        if (betView.posInfoArr.length == 1) {
            endNode = betView.chipPosList[BlackJackChipPos.base]
        }
        else {
            if (protoData.pos > 5) {
                endNode = betView.chipPosList[BlackJackChipPos.rightBase]
            }
            else {
                endNode = betView.chipPosList[BlackJackChipPos.leftBase]
            }
        }
        betView.chipMove(startNode, endNode, betView.baseEffect, protoData.betInfo[0].bet)
        this.makePokerMove(protoData.pos, betView, protoData.cardInfo.cards, true)
        betView.delayShowPoint()
        let num = parseFloat(protoData.betInfo[0].bet.toString()) * 2
        betView.delayShowCoin(protoData.pos, num)
        this.initBtnState(ButtonState.None)
    }
    makePokerMove(betPos: number, betView: BlackJackTableBetView, cards: number[], isDouble: boolean = false) {
        let pos = this.view.getPokerEndPos(betPos, betView)
        let parentNode = this.view.getPokerParent(betPos, betView)
        let code = cards[cards.length - 1]
        let poker = BlackJackUtility.makePoker(this.view.pokerPrefab.node, code, this.view.pokerStartNode, cards.length - 1)
        poker.isDouble = isDouble;
        //poker.node.position=BlackJackUtility.getConvertToNodeSpaceAR(parentNode,startNode)
        poker.node.angle = 25
        poker.showBack(true)
        poker.node.name = poker.node.name + "_" + cards.length
        cc.log("logicPokerMove")
        this.sendAckId(0.6)
        BlackJackUtility.moveToAction(poker.node, pos, 0.35, BlackJackUtility.playCardTurnAnim, poker, parentNode)
    }
    //发牌通知
    onNetMsgDealCardNotify(protoData: BlackJack.DealCardNotify) {
        // message PosInfo{
        //     optional uint32 pos = 1;
        //     optional int32 player_id = 3; //该座位下底注的玩家ID，即主玩家
        //     optional CardInfo card_info = 2;
        // }

        // repeated PosInfo pos_info = 1;//各座位发牌信息
        // repeated int32 banker_cards = 2; //庄家手牌 0表示牌背 其他表示相应牌
        // optional int32 banker_card_point = 3; //当前牌面点数
        // optional int32 deal_cnt = 4; //发牌张数 1表第一张 2表示 第二张
        this.view.roomIdTxt.string = protoData.roundSign
        if (protoData.dealCnt == 1) {
            this.gameState = BlackJackGameState.Give_One_Card
            this.view.hideEmptyBet()
            this.view.hideBetViewLight();
            this.view.sliderView.showPanel(false)
            this.view.hideSeatState()
            this.view.hideSeatMask()
            this.initBtnState(ButtonState.None)
        }
        else {
            this.gameState = BlackJackGameState.Give_Two_Card
        }
        for (let i = 0; i < protoData.posInfo.length; i++) {
            let seatNo = (protoData.posInfo[i].pos - 1) % 5 + 1
            let betView = this.view.getBetViewByPos(seatNo)
            betView.addCardInfo(protoData.posInfo[i].pos, protoData.posInfo[i].cardInfo, false)
        }
        //==============================================================================
        let maxCount = 0
        let pos: cc.Vec2;
        let poker: PokerTablePokerBase = null
        let startNode = this.view.pokerStartNode
        let code = 0;
        let seatNo = 0
        let betView: BlackJackTableBetView = null
        let parentNode: cc.Node = null
        let self = this
        self.cardMoveFun = function () {
            if (maxCount >= protoData.posInfo.length) {
                self.view.unschedule(self.cardMoveFun);
                // if(protoData.posInfo[maxCount-1].pos<=5 && betView.posInfoArr.length==1)
                // {
                //     betView.pokerPrefabList.push(poker)
                // }
                cc.log("发庄家")
                self.dealCardToBanker(protoData.bankerCards[protoData.dealCnt - 1], protoData.bankerCardPoint, protoData.dealCnt)
            }
            else {

                seatNo = (protoData.posInfo[maxCount].pos - 1) % 5 + 1
                betView = self.view.getBetViewByPos(seatNo)
                pos = self.view.getPokerEndPos(protoData.posInfo[maxCount].pos, betView)
                parentNode = self.view.getPokerParent(protoData.posInfo[maxCount].pos, betView)
                code = protoData.posInfo[maxCount].cardInfo.cards[protoData.dealCnt - 1]
                poker = BlackJackUtility.makePoker(self.view.pokerPrefab.node, code, startNode, maxCount)
                if (protoData.posInfo[maxCount].pos <= 5 && betView.posInfoArr.length == 1) {
                    betView.pokerPrefabList.push(poker)
                }
                poker.node.angle = 25
                poker.showBack(true)
                poker.node.name = poker.node.name + "_" + protoData.dealCnt
                if (protoData.dealCnt > 1) {
                    betView.delayShowPoint()
                }
                BlackJackSound.playDealCard();
                BlackJackUtility.moveToAction(poker.node, pos, 0.35, BlackJackUtility.playCardTurnAnim, poker, parentNode)
                maxCount++;
                //cc.log("maxCount:"+maxCount)
            }
        }

        self.view.doSchedule(this.cardMoveFun, 0.25, protoData.posInfo.length);
    }

    dealCardToBanker(code: number, bankerCardPoint: number, index: number) {


        let startNode = this.view.pokerStartNode
        let poker = BlackJackUtility.makePoker(this.view.pokerPrefab.node, code, startNode, index)
        this.view.bankPokerList.push(poker)

        poker.showBack(true)
        poker.node.name = poker.node.name + "_" + index
        let pos = BlackJackUtility.getConvertToNodeSpaceAR(startNode, this.view.bankPos)
        pos.x = pos.x + (index - 1) * 30
        let myParent = this.view.bankPos;
        let func = function () {
            poker.node.parent = myParent;
            poker.node.position = cc.Vec2.ZERO;
            let nameArr = poker.node.name.split("_")
            let num: number = Number(nameArr[1])
            num -= 1
            if (num > 0) {
                poker.node.position = new cc.Vec2(poker.node.position.x + num * 30, 0)
            }

            //this.initBank([],bankerCardPoint)
        }.bind(this)

        if (index != 2) {

            BlackJackUtility.moveToAction(poker.node, pos, 0.35, BlackJackUtility.playCardTurnAnim, poker, this.view.bankPos)
        }
        else {
            BlackJackSound.playDealCard();
            BlackJackUtility.moveToAction(poker.node, pos, 0.35, func, poker, this.view.bankPos)
        }
        //cc.log("dealCardToBanker")
        if (this.gameState == BlackJackGameState.Give_One_Card || this.gameState == BlackJackGameState.Give_Two_Card) {
            this.sendAckId(0.5)
        }
        else {
            this.sendAckId(1.5)
        }
        let bankPokerPos = this.view.bankerView.bankPokerPos
        if (this.view.bankPokerList.length > 2) {
            let xPos = (this.view.bankPokerList.length - 2) * 7
            bankPokerPos.position = new cc.Vec2(bankPokerPos.x - xPos, bankPokerPos.y)

        }

    }
    sendAckId(time: number = 0) {

        let ackID = this.ackId + 0
        // cc.log("ackID:" + ackID)
        // cc.log("lastSendAckId:" + this.lastSendAckId)
        if (this.gameSettleReason == GameResultState.GameOver) {
            return;
        }
        if (ackID != this.lastSendAckId) {
            this.view.doScheduleOnce(() => {
                this.model.send_Ack_request(ackID)
                this.lastSendAckId = ackID
            }, time);
        }



    }
    onNetMsgLeaveBroadcast(protoData: Room.LeaveBroadcast) {

        let isAvatar = protoData.playerId == this.myPlayerId;

        if (isAvatar) {

            if (!joinUtil.checkLeave(Number(protoData.reason), this.module)) {

                SceneManager.gotoHallOrClubHall("TabelExit");
            }

        } else {

            let newProtoData: BlackJack.OccupySeatNotify = new BlackJack.OccupySeatNotify()
            newProtoData.playerId = protoData.playerId;
            newProtoData.pos = 0;
            this.onNetMsgOccupySeatNotify(newProtoData)
        }

    }


    //落座通知
    onNetMsgOccupySeatNotify(protoData: BlackJack.OccupySeatNotify) {
        //optional uint32 pos = 1;//为0时表示旁观 其他表示落坐
        //optional int32 player_id = 2;
        //optional int32 coin_balance = 3; //玩家金币余额

        let seatView: BlackJackTableSeatView = null
        let betView: BlackJackTableBetView = null
        if (protoData.pos == 0)//离开人
        {
            EventManager.instance.dispatch("del_seatView_Info", protoData.playerId)
            seatView = this.view.getSeatViewById(protoData.playerId)
            seatView.posInfo = null
            seatView.showPanel()
            betView = this.view.getBetViewByPos(seatView.seatNo)
            betView.posInfoArr.length = 0
            betView.reset()
        }
        else//有人进来
        {
            let posInfo: BlackJack.PosInfo = new BlackJack.PosInfo()
            posInfo.pos = protoData.pos
            posInfo.playerId = protoData.playerId
            posInfo.coinBalance = protoData.coinBalance
            posInfo.userJson = protoData.userJson
            posInfo.isMainSeat = true
            seatView = this.view.getSeatView(protoData.pos)
            seatView.addPosInfo(posInfo)
            seatView.showPanel()
            betView = this.view.getBetViewByPos(posInfo.pos)
            betView.addPosInfo(posInfo)
            EventManager.instance.dispatch("push_seatView_Info", protoData.playerId, seatView.node.parent)
            if (this.gameState == BlackJackGameState.Beting) {
                let mySeatView = this.view.getSeatViewById(this.myPlayerId)
                seatView.countTotalTime = mySeatView.countTotalTime
                seatView.passTime = mySeatView.passTime
                seatView.reSetCountFrame(0)
                seatView.repeatTime()
            }
        }




    }
    removePlayer(playerId: number) {

        let len = this.allPosInfo.length
        for (let i = 0; i < len; i++) {
            if (this.allPosInfo[i]) {
                if (this.allPosInfo[i].playerId == playerId || (!this.allPosInfo[i].isMainSeat && this.allPosInfo[i].cardInfo == null)) {
                    this.allPosInfo.splice(i, 1)
                }
            }
        }
        //this.view.initTable()
        this.view.removeViewPlayer()
    }
    mainPlayerStandUp(info: BlackJack.PosInfo) {
        this.view.allSeatViewList[2].reset();
    }

    //下注通知
    onNetMsgBetNotify(protoData: BlackJack.BetNotify) {
        //optional uint32 pos = 1; //
        //optional int32 player_id = 3; //该座位下底注的玩家ID，即主玩家
        //optional int32 coin_balance = 2; //玩家金币余额
        //optional int32 bet=5;//下注金额
        //optional int32 bet_type = 4;//下注类型 0 表示 底注 1表示完美对子 2表示21+3 4续压 5旁注
        let startNode: cc.Node = null;
        let seatNo = (protoData.pos - 1) % 5 + 1
        let seatView: BlackJackTableSeatView = null
        let betView = this.view.getBetViewByPos(seatNo)
        let betInfo: BlackJack.Player.BetInfo = new BlackJack.Player.BetInfo()
        let posInfo: BlackJack.PosInfo = new BlackJack.PosInfo()


        seatView = this.view.getSeatView(protoData.pos)
        posInfo.playerId = protoData.playerId;
        posInfo.pos = protoData.pos;
        let mainSeatView = this.view.getSeatViewById(protoData.playerId)
        mainSeatView.setPlayerCoin(protoData.playerId,protoData.coinBalance)
        mainSeatView.isPlaying = true;
        if (seatView.posInfo == null) {
            cc.log("占位下注")
            posInfo.insurance = 0
            posInfo.insuranceFlag = false;
            posInfo.pos = protoData.pos
            posInfo.isMainSeat = false;
            seatView.addPosInfo(posInfo)
            betView.addPosInfo(posInfo)
            this.allPosInfo.push(posInfo)
            this.allPosInfo.sort(function (a, b) {
                return a.pos - b.pos
            })
            betView.showPanel()
        }
        betView.modifyPosInfo(mainSeatView.chipPos, protoData.pos, protoData.betType, protoData.bet)
        betView.delayShowCoin(protoData.pos, protoData.bet)
        //betView.showSideBetBtn() --减法

        if (this.moreBetClickPos != 0) {
            this.moreBetPos(this.moreBetClickPos)
        }
        if (protoData.playerId == this.myPlayerId) {
            this.curBetView = betView
            this.curSeatView = seatView
            this.myPlayerInfo.coinBalance = protoData.coinBalance
            this.checkEmptyBet()
            this.showContState()
            // cc.log("下注完步骤：" + betView.getBetSetp())
            // if (betView.getBetSetp() < 3 && this.myPlayerSeatNo != 0) {
            //     this.showContState();
            // }
        }
    }
    checkEmptyBet() {
        if (this.curBetView) {
            if (this.curBetView.getBetSetp() > 2) {
                this.view.showEmptyBet()
            }
        }
        else {
            let mainBetView = this.view.getBetViewByPos(this.myPlayerSeatNo)
            if (mainBetView.getBetSetp() > 2) {
                this.view.showEmptyBet()
            }
        }


    }

    onNetMsgBankerDealCardNotify(protoData: BlackJack.BankerDealCardNotify) {
        //repeated int32 cards = 1; //庄家手牌 0表示牌背 其他表示相应牌
        //optional int32 card_point = 2; //当前牌面点数
        //optional int32 status = 3;//状态 0 正常 1已经拿到黑杰克停牌 2、21点停牌 3爆牌停牌（庄家全赔） 4 大于16点停牌

        this.view.bankerView.showHand(0)
        if (protoData.cards.length == 2) {
            this.view.hideSeatState()
        }
        this.showBanker(protoData.cards, protoData.cardPoint, protoData.status)
    }
    showBanker(cards: number[], cardPoint: number, state: number = -1) {
        if (this.view.bankPokerList.length < 2) {
            return
        }
        if (cards.length == 2) //&& this.view.bankPokerList[1].spriteBack.node.active
        {
            if (cards[1] != 0 && this.view.bankPokerList[1].spriteBack.node.active) {
                this.view.bankPokerList[1].fillPoker(cards[1])
                //cc.log(this.view.bankPokerList[1].spriteBack.node.active + "背部的状态")
                BlackJackUtility.playCardTurnAnim(this.view.bankPokerList[1], null, 0.12, 0.01, null)
            }
        }
        else {
            if (cards.length > this.view.bankPokerList.length) {
                this.dealCardToBanker(cards[cards.length - 1], cardPoint, cards.length)
            }

        }
        if (cards[1] != 0) {
            this.view.bankerView.delayShowPoint(cards, cardPoint)
        }

    }
    checkPosInfo(posInfo: BlackJack.GameSettle.IPosInfo[]) {
        let playerIdArr: number[] = []
        let seatViewArr: BlackJackTableSeatView[] = []
        let seatView: BlackJackTableSeatView = null
        let index = 0
        for (let i = 0; i < posInfo.length; i++) {
            if (posInfo[i].playerId == this.myPlayerId) {
                continue
            }
            index = playerIdArr.indexOf(posInfo[i].playerId)
            if (index == -1) {
                seatView = this.view.getSeatViewById(posInfo[i].playerId)
                seatView.countMoney = posInfo[i].balance
                seatView.posInfoIdx = i
                seatViewArr.push(seatView)
            }
            else {
                seatViewArr[index].countMoney += posInfo[i].balance
            }
        }
        return seatViewArr
    }
    //结算
    onNetMsgGameSettle(protoData: BlackJack.GameSettle) {
        // repeated Player players = 1;//小局结算时
        // repeated PosInfo pos_info = 2;//
        // repeated int32 banker_cards = 3; //庄家手牌 0表示牌背 其他表示相应牌
        // optional int32 banker_card_point = 4; //当前牌面点数
        // optional int32 reason = 5; //结算原因 1保险 2完美对子结算 3、21+3结算 4、爆牌结算
        this.gameSettleReason = protoData.reason;
        this.initBtnState(ButtonState.None)
        if (this.curBetView) //消除牌遮罩
        {
            this.curBetView.PokerMask(-1)
        }
        this.showAllCountTime(0, false)
        this.showInsurance(false)
        let time = 0;
        if (protoData.reason == GameResultState.Insurance && protoData.bankerCardPoint == 21) {
            this.showBanker(protoData.bankerCards, 0)
            time = 1.3
        }
        let seatArr: BlackJackTableSeatView[] = this.checkPosInfo(protoData.posInfo)

        let self = this;

        this.view.doScheduleOnce(() => {
            self.showMainPlayerSettle(protoData.players, protoData.reason)
            self.showOtherPlayerSettle(protoData.posInfo, protoData.reason, seatArr)
            self.showBanker(protoData.bankerCards, protoData.bankerCardPoint)
            cc.log("this.myPlayerInfo.coinBalance:", self.myPlayerInfo.coinBalance);
            UserDataManager.balanceChangeMessage(self.myPlayerInfo.coinBalance)
        }, time);

    }


    showOtherPlayerSettle(posInfo: BlackJack.GameSettle.IPosInfo[], reason: number, seatViewArr: BlackJackTableSeatView[]) {
        //    message PosInfo {
        //     optional uint32 pos = 1;//1~5为左手位 6~10为右手位
        //     repeated int32 cards = 5; //手牌
        //     repeated int32 card_point = 2; //当前牌面点数 有可能存在两种点数，最大点数放在位置1 然后是第二大点数
        //     optional int32 player_id = 3; //该座位下底注的玩家ID，即主玩家
        //     optional int32 bet = 6;
        //     optional int32 balance = 4; //结余(不是余额) 负数表示输了多少，正数表示赢了多少
        //     optional int32 totalbalance = 7;//当前本局一共输赢多少
        // }
        if (posInfo.length == 0) {
            return
        }
        let maxCount = 0
        let pos = 0
        let betView: BlackJackTableBetView = null
        let moveEffect: BlackJackBetMoveEffect = null
        let endNode: cc.Node;
        let myReason = reason;
        let seatView: BlackJackTableSeatView = null
        let newSeatArr = seatViewArr
        let self = this
        self.showPosChipMove = function () {
            if (maxCount >= posInfo.length) {
                self.view.unschedule(self.showPosChipMove);

                for (let i = 0; i < newSeatArr.length; i++) {
                    newSeatArr[i].showResult(true)
                    if (myReason == GameResultState.GameOver) {
                        newSeatArr[i].showTotalResult(posInfo[newSeatArr[i].posInfoIdx].totalBalance)
                    }
                }
            }
            else {
                if (posInfo[maxCount] &&  posInfo[maxCount].playerId != self.myPlayerId) {

                    //cc.log("其他玩家飞"+maxCount)
                    pos = (posInfo[maxCount].pos - 1) % 5 + 1
                    betView = self.view.getBetViewByPos(pos)
                    seatView = self.view.getSeatViewById(posInfo[maxCount].playerId)                   

                    if (posInfo[maxCount].balance >= 0) {
                        if (posInfo[maxCount].balance > 0) {
                            //cc.log("庄家飞玩家"+maxCount)
                            self.effectBack(betView.bankEffect, posInfo[maxCount].balance, self.view.bankcollectPos, seatView.chipPos)
                        }
                        //cc.log("betView飞玩家"+maxCount)
                        moveEffect = betView.getEffectByReason(myReason, posInfo[maxCount].pos)
                        //cc.log("飞："+betView.seatNo,moveEffect.node.name)
                        endNode = seatView.chipPos
                        moveEffect.guiChi(endNode)
                    }
                    else {
                        //cc.log("betView飞庄家"+maxCount)
                        moveEffect = betView.getEffectByReason(myReason, posInfo[maxCount].pos)
                        endNode = self.view.bankcollectPos
                        moveEffect.guiChi(endNode)

                    }
                    if (myReason == GameResultState.Insurance)
                        self.clearInsuranceCoin(betView, posInfo[maxCount].pos)

                    if (myReason != GameResultState.bombPoker) {    
                        //爆牌不更新余额             
                        seatView.setPlayerCoin(posInfo[maxCount].playerId, posInfo[maxCount].coinBalance);                    
                    }                                        
                }                                                
                maxCount++;
            }
        }
        
        self.view.doSchedule(self.showPosChipMove, 0.05, posInfo.length);
    }

    showMainPlayerSettle(players: BlackJack.GameSettle.IPlayer[], reason: number) {
        //     optional int32 player_id = 1; //玩家ID
        //     optional uint32 pos = 2; //下注位置 1~5为左手位 6~10为左手位
        //     optional int32 coin_balance = 4; //用户结算后的金币余额
        //     optional int32 bet = 3;//下注金额
        //     optional int32 current_coin_balance = 5; //本次结算金币结余 负数表示输了多少，正数表示赢了多少
        //     optional int32 reason = 5; //结算原因 1保险 2完美对子结算 3、21+3结算 4、爆牌结算
        if (players.length == 0) {
            return
        }
        let mainSeatView: BlackJackTableSeatView = this.view.getSeatView(this.myPlayerSeatNo)
        let betView: BlackJackTableBetView = null
        let pos = 0;
        let endNode: cc.Node = null
        this.myPlayerInfo.coinBalance = players[0].coinBalance
        let maxCount = 0
        let myReaon = reason
        mainSeatView.countMoney = 0;
        let self = this
        self.betViewMove = function () {
            if (maxCount >= players.length) {
                self.unschedule(self.betViewMove);
                if (mainSeatView) {
                    mainSeatView.showResult(true)
                    if (myReaon == GameResultState.GameOver) {
                        mainSeatView.showTotalResult(players[0].totalBalance)
                    }
                }
            }
            else {
                pos = (players[maxCount].pos - 1) % 5 + 1
                betView = self.view.getBetViewByPos(pos)

                if (players[maxCount].currentCoinBalance >= 0) {
                    endNode = mainSeatView.chipPos
                    if (players[maxCount].currentCoinBalance > 0)//庄家飞座位
                    {
                        self.effectBack(betView.bankEffect, players[maxCount].currentCoinBalance, self.view.bankcollectPos, endNode)
                    }
                }
                else  //下注位飞庄家位
                {
                    endNode = self.view.bankcollectPos
                }
                mainSeatView.countMoney += players[maxCount].currentCoinBalance
                betView.chipMoveBack(reason, endNode, players[maxCount].pos)
                if (myReaon == GameResultState.Insurance && players[maxCount].currentCoinBalance < 0)
                    self.clearInsuranceCoin(betView, players[maxCount].pos)

                maxCount++;
            }
        }
        self.view.doSchedule(self.betViewMove, 0.05, players.length);
        mainSeatView.setPlayerCoin(self.myPlayerInfo.playerId,self.myPlayerInfo.coinBalance)

        this.module.eventDispatch("Game_Table_Settlement", mainSeatView.playerIcon.node);
        //UserDataManager.setUserGameTableCurrency(self.myPlayerInfo.playerId, self.myPlayerInfo.coinBalance);
    }
    clearInsuranceCoin(betView: BlackJackTableBetView, pos: number) {
        let num = betView.posInfoArr[0].base
        betView.delayShowCoin(pos, num)
    }
    effectBack(moveEffect: BlackJackBetMoveEffect, coin: number, startNode: cc.Node, endNode: cc.Node) {
        moveEffect.purposeNode = startNode
        moveEffect.showBet(coin)
        moveEffect.guiChi(endNode)
    }
    //下注回复
    onNetMsgBetRsp(protoData: BlackJack.BetRsp) {
        if (protoData.errNo != 0 && protoData.errNo != 3 && protoData.errNo != 4 && protoData.errNo != 5) {
            this.onNormalRsp(protoData.errNo)
        }
        else if (protoData.errNo == 3 || protoData.errNo == 4 || protoData.errNo == 5) {
            let betView = this.view.getBetViewByPos(protoData.pos)
            betView.showNotice(true, "ErrNo" + protoData.errNo)
            this.view.doScheduleOnce(() => {
                betView.showNotice(false, "")
            }, 1.5);
        }
    }
    //落座回复
    onNetMsgOccupySeatRsp(protoData: BlackJack.OccupySeatRsp) {
        if (protoData.errNo != 0 && protoData.errNo != 3) {
            this.onNormalRsp(protoData.errNo)
        }
        else if (protoData.errNo == 3) {
            ModuleManager.instance.toast("该位置已有人下注，无法落座");
        }
    }
    //双倍回复
    onNetMsgDoubleBetRsp(protoData: BlackJack.DoubleBetRsp) {

        if (protoData.errNo != 0) {
            this.onNormalRsp(protoData.errNo)
        }
    }
    //分牌回复
    onNetMsgEnableRightRsp(protoData: BlackJack.EnableRightRsp) {
        if (protoData.errNo != 0 && protoData.errNo != 3) {
            this.onNormalRsp(protoData.errNo)
        }
        else if (protoData.errNo == 3) {
            ModuleManager.instance.toastKey("bj_Not_Separate")
        }
    }
    //要牌回复
    onNetMsgMoreCardRsp(protoData: BlackJack.MoreCardRsp) {
        if (protoData.errNo != 0) {
            this.onNormalRsp(protoData.errNo)
        }

    }
    //停牌回复
    onNetMsgNoMoreCardRsp(protoData: BlackJack.NoMoreCardRsp) {
        if (protoData.errNo != 0) {
            this.onNormalRsp(protoData.errNo)
        }
    }

    //保险回复
    onNetMsgInsuranceRsp(protoData: BlackJack.InsuranceRsp) {
        if (protoData.errNo != 0) {
            this.onNormalRsp(protoData.errNo)
        }
    }


    onUserCoinBalanceNotify(data : {playerId: number, coinBalance: number}){
        let seatView = this.view.getSeatViewById(data.playerId)
        if (seatView) {
            seatView.setPlayerCoin(data.playerId,data.coinBalance);
        }        
    }
    

    onNormalRsp(state: number) {
        if (state == 1) {
            ModuleManager.instance.toastKey("bj_Not_Polling");
        }
        else if (state == 2) {
            ModuleManager.instance.toastKey("bj_Not_Operation");
        }
        else if (state == 5) {
            ModuleManager.instance.toastKey("bj_Not_Money");
        }
    }
    onNetMsgNoBetNotify(protoData: BlackJack.NoBetNotify) {
        //required int32 player_id = 1;//玩家ID
        //required int32 seat_id = 2;//当前玩家所在座位 1~5
        //required int32 no_bet_cnt = 3;//连续未下注次数
        // if (protoData.noBetCnt == 1) {
        //     ModuleManager.instance.toast("您本局未下注，如果连续两局未下注，\n将会自动把您踢出座位，请您及时下注！");
        // }
        // else if (protoData.noBetCnt == 2) {
        ModuleManager.instance.toastKey("bj_Not_Bet");
        //}
    }
    //下注完成通知
    onNetMsgBetFinishNotify(protoData: BlackJack.BetFinishNotify) {
        let seatView = this.view.getSeatView(protoData.seatId)
        seatView.showState("CompleteBet", true);
        seatView.stopCountTime()
    }
    //下注完成回复
    onNetMsgBetFinishRsp(protoData: BlackJack.BetFinishRsp) {

    }

}
